import React from "react";
import { Item } from "../Item";
import { Button } from "./styles";
import { useTranslation } from "react-i18next";
import { API } from "../../../../../shared/services";
import { toast } from "react-toastify";
import { useContacts, useContactsState } from "../../../contexts";

export const ReOpen = ({ children }) => {
  const { t } = useTranslation("Customer");
  const { updateCurrentContact } = useContacts();
  const { currentContact } = useContactsState();

  function handleClick() {
    const OPEN_STATUS = "open";

    API.put(`customers/${currentContact.id}`, {
      customer: {
        status: OPEN_STATUS,
      },
    })
      .then(() => {
        updateCurrentContact({
          ...currentContact,
          status: "open",
        });

        toast.success(t("details.reOpen.actionSuccess"));
      })
      .catch(() => {
        toast.success(t("details.reOpen.actionFail"));
      });
  }

  return (
    <Button onClick={handleClick} variant="contained">
      {children}
    </Button>
  );
};

const Container = () => {
  const { t } = useTranslation("Customer");

  return (
    <Item>
      <ReOpen>
        <span>{t("details.reOpen.action")}</span>
      </ReOpen>
    </Item>
  );
};

export default Container;
